<h1 class="center">Gestion linge d'hébergement</h1>
<div class="flex justify-center">
	<div class="clamp-commande">
		<div class="mat-tree-table">
			<div class="header">
				<div>Date de livraison</div>
				<div class="icon-custom">Statut
					<mat-icon (click)="help()" class="icon-click">help</mat-icon>
				</div>
				<div [ngClass]="'list-actions-2'"></div>
			</div>
			<mat-tree [dataSource]="ELEMENT_DATA" [treeControl]="treeControl" class="example-tree">
				<mat-nested-tree-node *matTreeNodeDef="let node; when: hasChildren"
					[ngClass]="'besoin' + (isToday(node.date_livraison) ? '-today' : '')">
					<div class="mat-tree-node">
						<button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.id">
							<mat-icon>
								{{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
							</mat-icon>
						</button>
						<div class="node-title">{{ node.date_livraison | date: 'EEEE': 'fr' | titlecase }} -
							{{ node.date_livraison | date: 'dd/MM/yyyy': 'fr'}}
						</div>
						<div>
							<span [ngClass]="'state-circle ' + 'state-circle-' + node.statut.code"></span>
							{{ node.statut.libelle }}
						</div>
						<div [ngClass]="'list-actions-2'">
							<mat-icon (click)="getCommandeDetails(node)" matTooltip="Voir plus">visibility</mat-icon>
							<a *ngIf="isEditable(node)" class="besoin-list-button" routerLink="../edit-besoin"
								[queryParams]="{ id: node.id }">
								<mat-icon matTooltip="Modifier">create</mat-icon>
							</a>
							<mat-icon *ngIf="isPrintable(node)" (click)="export(node.id)" matTooltip="Exporter">picture_as_pdf</mat-icon>
							<a *ngIf="isPartiel(node)" class="besoin-list-button" routerLink="../dispatch-besoin"
								[queryParams]="{ id: node.id }">
								<mat-icon matTooltip="Répartir la livraison"
									style="transform: rotate(90deg)">call_split</mat-icon>
							</a>
						</div>
					</div>
					<ul *ngIf="treeControl.isExpanded(node)">
						<div class="node">
							<ng-container matTreeNodeOutlet></ng-container>
						</div>
					</ul>
				</mat-nested-tree-node>
				<mat-nested-tree-node *matTreeNodeDef="let node" class="lingerie">
					<li>
						<div class="lines-tree"></div>
						<div class="mat-tree-node">
							<div>
								{{node.lingerie?.libelle}}
							</div>
							<div class="node-title">{{node.date_modification == NULL ? "": "Modifié le
								"}}{{node.date_modification | date: 'dd/MM/yyyy': 'fr'}}
							</div>
							<div>
								<span [ngClass]="'state-circle ' + 'state-circle-' + node.statut.code"></span>
								{{ node.statut.libelle }}
							</div>
							<div [ngClass]="'list-actions-2'">
								<a (click)="getInventaireDetails(node)" class="besoin-list-button">
									<mat-icon [matTooltip]="disabledVoir(node) ? '' : 'Voir plus'"
										[ngClass]="{'disabled' : disabledVoir(node)}">visibility</mat-icon>
								</a>
								<a *ngIf="isEditableInventaire(node)" class="besoin-list-button"
									routerLink="../edit-inventaire" [queryParams]="{ id: node.id }">
									<mat-icon matTooltip="Modifier">create</mat-icon>
								</a>
							</div>
						</div>
					</li>
				</mat-nested-tree-node>
			</mat-tree>
		</div>
		<div [hidden]="ELEMENT_DATA.data.length == 0">
			<mat-paginator [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
		</div>
	</div>
</div>

<mat-sidenav-container class="sidenav-container">
	<mat-sidenav class="sidenav-content" #sidebar [opened]="isSideBarOpen" (closed)="onSidebarClose()" position="end">
		<h3 class="sidenav-content-title">
			Liste des articles de l'inventaire du {{ dateLivraison | date: 'EEEE':
			'fr' }} {{ dateLivraison | date: 'dd/MM/yyyy': 'fr'}} :
		</h3>
		<div class="flex items-center flex-col">
			<table class="styled-table">
				<thead>
					<tr>
						<th>Article</th>
						<th>Besoin</th>
						<th *ngIf="delivered()">Livraison</th>
						<th *ngIf="delivered() && hasQteReception()">Réception</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let data of sideBarData">
						<td>{{ data.article.designation }}</td>
						<td>{{ data.quantite }}</td>
						<td *ngIf="delivered()">{{ data.qte_livree }}</td>
						<td *ngIf="delivered() && hasQteReception()">{{ data.qte_reception }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</mat-sidenav>
</mat-sidenav-container>

<mat-sidenav-container class="sidenav-container">
	<mat-sidenav class="sidenav-content" #sidebarInventaire [opened]="isSideBarInventaireOpen"
		(closed)="onSidebarInventaireClose()" position="end">
		<h3 class="sidenav-content-title">
			Liste des articles de l'inventaire du {{ dateLivraison | date: 'EEEE':
			'fr' }} {{ dateLivraison | date: 'dd/MM/yyyy': 'fr'}} :
		</h3>
		<h3 class="sidenav-subtitle">
			Lingerie '{{ sideBarInventaireData?.lingerie?.libelle }}'
		</h3>
		<div class="sidenav-content-list">
			<table class="styled-table">
				<thead>
					<tr>
						<th>Article</th>
						<th>Dotation</th>
						<th>Restant</th>
						<th>Besoin</th>
						<th *ngIf="hasDispatch()">Dispatch</th>
						<th *ngIf="enabledComplement && hasComplement()">Complement</th>
						<th *ngIf="enabledComplement && hasDistribution()">Distribution</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let data of sideBarInventaireData?.inventaire_lignes">
						<td>{{ data.article.designation }}</td>
						<td>{{ data.dotation }}</td>
						<td>{{ data.restant }}</td>
						<td>{{ data.qte_commande }}</td>
						<td *ngIf="hasDispatch()">{{ data.qte_dispatch }}</td>
						<td *ngIf="enabledComplement && hasComplement()">{{ data.qte_complement ?? 0 }}</td>
						<td *ngIf="enabledComplement && hasDistribution()">{{ data.qte_livree ?? data.qte_dispatch }}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</mat-sidenav>
</mat-sidenav-container>